
import {Vue, Component, Prop} from 'vue-property-decorator';
@Component
export default class Tag extends Vue {
  @Prop({required: true, default: '', type: String}) private tag!: string;
  public render(h: any) {
    return h(this.tag, this.$slots.default);
  }
}
